import styles from "./styles.module.scss";
import logo from "../../img/KMMLogo.jpg";
import mobLogo from "../../img/kmlogo.png";
import { useEffect, useRef, useState } from "react";
import DownArrow from "../DownArrow";
import i18n from "../../i18n";

type HeaderProps = {
  switched?: boolean;
};

const Header = ({ switched = false }: HeaderProps) => {
  const dropdownVariation = ["en", "ru", "ro"];
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownValue, setDropdownValue] = useState("en");
  const dropdownContainerRef = useRef<HTMLDivElement>(null);

  const changeLanguageHandler = (lang: string) => {
    i18n.changeLanguage(lang);
  }

  return (
    <div className={styles.header}>
      <img className={styles.img} src={logo} alt="logo" />
      <div
        ref={dropdownContainerRef}
        style={{ display: "flex", position: "relative" }}
        className={styles.selectWr}
        onMouseLeave={() => {
          setDropdownOpen(false)
        }}
      >
        <div
          className={`${styles.select}`}
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          <p className={`${styles.text} m-0`}>{dropdownValue}</p>
          <DownArrow className={styles.arrow} dark={switched} />
        </div>
        <div className={`${styles.optionWr} ${dropdownOpen ? styles.active : ""}`}>
          {dropdownVariation.map((lang, id) => {
            if (lang !== dropdownValue) {
              return (
                <div
                  key={id}
                  className={styles.option}
                  onClick={() => {
                    setDropdownValue(lang);
                    changeLanguageHandler(lang);
                    setDropdownOpen(false);
                  }}
                >
                  {lang}
                </div>
              );
            }
          })}
        </div>
      </div>
    </div>
  )
}

export default Header;
